// The in-app frame logger: raw performance.now() timestamps, one per PixiJS
// ticker callback, into a buffer allocated once up front. record() does no
// allocation and no logging, so the logger cannot cause the stalls it measures.
//
// Capacity: 15 minutes at 120 fps (108,000 frames, 864 KB). Spec floor is
// 12 minutes at 120 fps. Frames past capacity are counted in `overflow`, never
// silently dropped.

export const DEFAULT_CAPACITY = 120 * 60 * 15

export function createFrameLogger(capacity = DEFAULT_CAPACITY) {
    const buffer = new Float64Array(capacity)
    let count = 0
    let overflow = 0
    let recording = false
    let startMs = NaN
    let stopMs = NaN

    return {
        buffer,
        capacity,
        get count() { return count },
        get overflow() { return overflow },
        get recording() { return recording },
        get startMs() { return startMs },
        get stopMs() { return stopMs },

        start(t) {
            count = 0
            overflow = 0
            startMs = t
            stopMs = NaN
            recording = true
        },

        record(t) {
            if (!recording) return
            if (count < capacity) buffer[count++] = t
            else overflow++
        },

        stop(t) {
            recording = false
            stopMs = t
        },

        // After the run only: copies the recorded frames out (allocates).
        timestamps(decimals = 3) {
            const f = 10 ** decimals
            const out = new Array(count)
            for (let i = 0; i < count; i++) out[i] = Math.round(buffer[i] * f) / f
            return out
        },
    }
}
